import type { CloudRuntimeTerminalFailureResidual } from "./cloudRuntimeTerminalFailureResidual";

export function isCloudRuntimeTerminalFailureResidual(
  value: unknown,
): value is CloudRuntimeTerminalFailureResidual {
  if (!value || typeof value !== "object") return false;
  const record = value as Record<string, unknown>;
  const nullableString = (key: string) => {
    const field = record[key];
    return field === null || typeof field === "string";
  };
  return (
    nullableString("stage") &&
    nullableString("runtimeId") &&
    nullableString("environmentId") &&
    nullableString("status") &&
    nullableString("spriteName") &&
    nullableString("readinessPhase") &&
    nullableString("ensureDetail") &&
    (record.retryable === null || typeof record.retryable === "boolean")
  );
}
